/**
 * Truncates any characters of the given string exceeding the given length
 * when the string is truncated, a clamp is appended
 *
 * @see https://stackoverflow.com/a/43666185
 * 
 * @param str
 * @description String to truncate
 * 
 * @param length
 * @description Length after which the string should be truncated
 * 
 * @param clamp
 * @default: ...
 * @description Clamp to append to string after truncate
 * 
 * @return Full, or truncated string depending on string length
 */
export default (str, length, clamp) => {
    if(!str || !length || str.length <= length){
        return str;
    }
    
    if(clamp === undefined){
        clamp = '...';
    }
    
    return str.substring(0, length) + (clamp || '...');
}